import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setAuthorizationToken } from '../utils/setAuthorizationToken';
import { userAPI } from '../api/userAPI';
import { appLoading, setMessage, setIsAuthenticated } from './appSlice';

// async thunk request to User Request
export const getUserRequest = createAsyncThunk(
  'user/getUserRequest',
  // eslint-disable-next-line
  async (userdata, { dispatch, rejectWithValue }) => {
    try {
      dispatch(appLoading(true));
      const data = await userAPI.getCpUser();
      dispatch(setUserDetail(data));
      dispatch(appLoading(false));
    } catch (error) {
      if (error.response) {
        dispatch(appLoading(false));
        localStorage.removeItem('dbToken');
        return rejectWithValue(error.response.data.message);
      }
    }
  }
);

// async thunk request to Login
export const loginRequest = // eslint-disable-next-line
  createAsyncThunk('user/loginRequest', async (userdata, { dispatch, rejectWithValue }) => {
    try {
      const getToken = await userAPI.loginRequest(userdata);
      localStorage.setItem('dbToken', JSON.stringify(getToken.accessToken));
      localStorage.setItem('dbRefToken', JSON.stringify(getToken.refreshToken));
      setAuthorizationToken(getToken.accessToken);
      dispatch(setIsAuthenticated(true));
      dispatch(getUserRequest());
    } catch (error) {
      if (error.response) {
        return rejectWithValue(error.response.data.message);
      }
    }
  });

// async thunk request to get refresh token
export const refreshTokenRequest = // eslint-disable-next-line
  createAsyncThunk('user/refreshTokenRequest', async (userdata, { dispatch, rejectWithValue }) => {
    try {
      const getToken = await userAPI.refreshToken(userdata);
      localStorage.setItem('dbToken', JSON.stringify(getToken.accessToken));
      localStorage.setItem('dbRefToken', JSON.stringify(getToken.refreshToken));
      setAuthorizationToken(getToken.accessToken);
      dispatch(setIsAuthenticated(true));
      dispatch(getUserRequest());
    } catch (error) {
      if (error.response) {
        dispatch(setIsAuthenticated(false));
        localStorage.removeItem('dbToken');
        localStorage.removeItem('dbRefToken');
        return rejectWithValue(error.response.data.message);
      }
    }
  });

// async thunk request to User Log OUT
// eslint-disable-next-line
export const userLogoutRequest = createAsyncThunk(
  'user/userLogoutRequest',
  // eslint-disable-next-line
  async (userdata, { dispatch, rejectWithValue }) => {
    try {
      dispatch(appLoading(true));
      const data = await userAPI.logoutCall();
      dispatch(setMessage(data.message));
      localStorage.removeItem('dbToken');
      setAuthorizationToken(false);
      dispatch(setIsAuthenticated(false));
      dispatch(appLoading(false));
    } catch (error) {
      if (error.response) {
        dispatch(appLoading(false));
        return rejectWithValue(error.response.data.message);
      }
    }
  }
);

// async thunk request to get Business Config
// eslint-disable-next-line
export const getBusinessConfigRequest = createAsyncThunk(
  'user/getBusinessConfigRequest',
  // eslint-disable-next-line
  async (userdata, { dispatch, rejectWithValue }) => {
    try {
      const data = await userAPI.getConfig();
      dispatch(setConfig(data));
    } catch (error) {
      if (error.response) {
        return rejectWithValue(error.response.data.message);
      }
    }
  }
);

// async thunk request to update Business Config
// eslint-disable-next-line
export const updateBusinessConfigRequest = createAsyncThunk(
  'user/updateBusinessConfigRequest',
  // eslint-disable-next-line
  async (userData, { dispatch, rejectWithValue }) => {
    try {
      const data = await userAPI.updateConfig(userData);
      dispatch(setMessage(data.message));
    } catch (error) {
      if (error.response) {
        return rejectWithValue(error.response.data.message);
      }
    }
  }
);

// async thunk request to User Log OUT
export const changePasswordRequest = createAsyncThunk(
  'user/changePasswordRequest',
  // eslint-disable-next-line
  async (userdata, { dispatch, rejectWithValue }) => {
    try {
      dispatch(appLoading(true));
      const data = await userAPI.changePassword();
      dispatch(setMessage(data.message));
      dispatch(appLoading(false));
    } catch (error) {
      if (error.response) {
        dispatch(appLoading(false));
        return rejectWithValue(error.response.data.message);
      }
    }
  }
);

const initialState = {
  userDetails: {},
  config: {},
  hasError: ''
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserDetail: (state, action) => {
      state.userDetails = action.payload;
    },
    setConfig: (state, action) => {
      state.config = action.payload;
    },
    clearHasError: (state) => {
      state.hasError = '';
    }
  },
  extraReducers: {
    [getUserRequest.rejected]: (state, action) => {
      state.hasError = action.payload;
    },
    [loginRequest.rejected]: (state, action) => {
      state.hasError = action.payload;
    },
    [userLogoutRequest.rejected]: (state, action) => {
      state.hasError = action.payload;
    },
    [changePasswordRequest.rejected]: (state, action) => {
      state.hasError = action.payload;
    },
    [getBusinessConfigRequest.rejected]: (state, action) => {
      state.hasError = action.payload;
    }
  }
});
export const { setUserDetail, clearHasError, setConfig } = userSlice.actions;

export default userSlice.reducer;
